import { render, staticRenderFns } from "./ViewSetup.vue?vue&type=template&id=7e239580&scoped=true&"
import script from "./ViewSetup.vue?vue&type=script&lang=ts&"
export * from "./ViewSetup.vue?vue&type=script&lang=ts&"
import style0 from "./ViewSetup.vue?vue&type=style&index=0&id=7e239580&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e239580",
  null
  
)

export default component.exports